import { OPEN_MODAL } from "layout/redux/overlay.actions";

const handleOpenModal = (modal:any, stickyLink:any, dispatch) => {
    dispatch({
        type: OPEN_MODAL,
        stickyLink: stickyLink,
        modal: modal,
    });
};

export default handleOpenModal;